/* eslint-disable no-unused-vars */
/**
 * @description Class containing the initial configuration style textarea
 * @author ConfigInitTable?
 * @version 1.0.0
 */
'use strict';
// Modules
import * as CSS from 'csstype'

// Others
import { InitConfigColor } from '../../utils/colors'
const Colors = InitConfigColor.getColors()
import { numberFormat } from '../../utils'
import { CSSObject } from 'styled-components';
import { useCallback } from 'react';

// Declare type
export declare type TDefaultTextAreaStyle = {
    container?: {
        styles?: CSSObject
        mediaTable?: boolean
        mediaPhone?: boolean
        stylesTable?: CSSObject
        stylesPhone?: CSSObject
        width?: CSS.Property.Width
        margin?: CSS.Property.Margin
        minWidth?: CSS.Property.Width
        maxWidth?: CSS.Property.Width
        display?: CSS.Property.Display
        widthTable?: CSS.Property.Width
        widthPhone?: CSS.Property.Width
        position?: CSS.Property.Position
        maxWidthPhone?: CSS.Property.MaxWidth
        maxWidthTable?: CSS.Property.MaxWidth
        flexDirection?: CSS.Property.FlexDirection
        hoverDisplayTooltip?: CSS.Property.Display
    }
    label?: {
        styles?: CSSObject
        activeTitle?: boolean
        color?: CSS.Property.Color
        margin?: CSS.Property.Margin
        border?: CSS.Property.Border
        padding?: CSS.Property.Padding
        colorError?: CSS.Property.Color
        fontSize?: CSS.Property.FontSize
        overflow?: CSS.Property.Overflow
        colorNotValue?: CSS.Property.Color
        colorDisabled?: CSS.Property.Color
        textAlign?: CSS.Property.TextAlign
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        textOverflow?: CSS.Property.TextOverflow
        hoverDisplayTooltip?: CSS.Property.Display
    }
    textarea?: {
        styles?: CSSObject
        activeTitle?: boolean
        width?: CSS.Property.Width
        color?: CSS.Property.Color
        border?: CSS.Property.Border
        padding?: CSS.Property.Padding
        outline?: CSS.Property.Outline
        fontSize?: CSS.Property.FontSize
        borderError?: CSS.Property.Border
        borderFocus?: CSS.Property.Border
        minHeight?: CSS.Property.MinHeight
        textAlign?: CSS.Property.TextAlign
        colorDisabled?: CSS.Property.Color
        borderSuccess?: CSS.Property.Border
        fontFamily?: CSS.Property.FontFamily
        cursorDisabled?: CSS.Property.Cursor
        transform?: CSS.Property.TextTransform
        colorDisabledClick?: CSS.Property.Color
        borderRadius?: CSS.Property.BorderRadius
        cursorDisabledClick?: CSS.Property.Cursor
        hoverDisplayTooltip?: CSS.Property.Display
        fontFamilyDisabled?: CSS.Property.FontFamily
        backgroundColor?: CSS.Property.BackgroundColor
        fontFamilyDisabledClick?: CSS.Property.FontFamily
        backgroundColorDisabled?: CSS.Property.BackgroundColor
        backgroundColorDisabledClick?: CSS.Property.BackgroundColor
    }
    tooltip?: {
        styles?: CSSObject
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        border?: CSS.Property.Border
        bottom?: CSS.Property.Bottom
        padding?: CSS.Property.Padding
        display?: CSS.Property.Display
        fontSize?: CSS.Property.FontSize
        position?: CSS.Property.Position
        topAfterBefore?: CSS.Property.Top
        boxShadow?: CSS.Property.BoxShadow
        leftAfterBefore?: CSS.Property.Left
        fontFamily?: CSS.Property.FontFamily
        borderAfterBefore?: CSS.Property.Border
        bottomAfterBefore?: CSS.Property.Bottom
        borderRadius?: CSS.Property.BorderRadius
        contentAfterBefore?: CSS.Property.Content
        positionAfterBefore?: CSS.Property.Position
        backgroundColor?: CSS.Property.BackgroundColor
        pointerEventsAfterBefore?: CSS.Property.PointerEvents
    }
    symbol?: {
        styles?: CSSObject
        left?: CSS.Property.Left
        color?: CSS.Property.Color
        bottom?: CSS.Property.Bottom
        position?: CSS.Property.Position
        fontSize?: CSS.Property.FontSize
        colorDisabled?: CSS.Property.Color
        fontFamily?: CSS.Property.FontFamily
        colorDisabledClick?: CSS.Property.Color
        fontFamilyDisabled?: CSS.Property.FontFamily
        fontFamilyDisabledClick?: CSS.Property.FontFamily
    }
    messageError?: {
        pass?: string
        email?: string
        letter?: string
        numeric?: string
        required?: string
        date?: (value: string) => string
        hour?: (value: string) => string
        minimum?: (value: number) => string
        maximum?: (value: number) => string
        range?: (min: number, max: number) => string
    }
    loading?: {
        container?: Node
        size?: string | number
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        right?: CSS.Property.Right
        color?: CSS.Property.Color
        bottom?: CSS.Property.Bottom
        position?: CSS.Property.Position
    }
    tooltipTextArea?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        maxWidth?: CSS.Property.Width
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        fontSize?: CSS.Property.FontSize
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        maxHeight?: CSS.Property.MaxHeight
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        visibility?: CSS.Property.Visibility
        textOverflow?: CSS.Property.TextOverflow
        borderRadius?: CSS.Property.BorderRadius
        backgroundColor?: CSS.Property.BackgroundColor
    }
    tooltipLabel?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        maxWidth?: CSS.Property.Width
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        fontSize?: CSS.Property.FontSize
        maxHeight?: CSS.Property.MaxHeight
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        visibility?: CSS.Property.Visibility
        borderRadius?: CSS.Property.BorderRadius
        textOverflow?: CSS.Property.TextOverflow
        backgroundColor?: CSS.Property.BackgroundColor
    }
    boxTextArea?: {
        styles?: CSSObject
    }
}

export let defaultStyle: TDefaultTextAreaStyle = {
    container: {
        width: '100%',
        display: 'flex',
        widthPhone: '100%',
        widthTable: '100%',
        position: 'relative',
        maxWidthTable: '768px',
        maxWidthPhone: '375px',
        flexDirection: 'column',
        hoverDisplayTooltip: 'block'
    },
    label: {
        border: 'none',
        margin: '1px 0',
        fontSize: '13px',
        activeTitle: true,
        textAlign: 'start',
        overflow: 'hidden',
        padding: '5.2px 0px',
        whiteSpace: 'nowrap',
        fontFamily: 'sans-serif',
        textOverflow: 'ellipsis',
        color: Colors.textarea?.label,
        hoverDisplayTooltip: 'block',
        colorError: Colors.textarea?.labelError,
        colorNotValue: Colors.textarea?.labelLight,
        colorDisabled: Colors.textarea?.labelHight,
    },
    textarea: {
        outline: '0',
        width: '100%',
        padding: '0 7px',
        fontSize: '13px',
        minHeight: '36px',
        activeTitle: true,
        borderRadius: '5px',
        fontFamily: 'sans-serif',
        cursorDisabled: 'no-drop',
        color: Colors.textarea?.textarea,
        hoverDisplayTooltip: 'block',
        cursorDisabledClick: 'pointer',
        fontFamilyDisabled: 'sans-serif',
        fontFamilyDisabledClick: 'sans-serif',
        colorDisabled: Colors.textarea?.textareaHight,
        colorDisabledClick: Colors.textarea?.primary,
        border: `1px solid ${Colors.textarea?.textareaBorder}`,
        borderFocus: `1px solid ${Colors.textarea?.primary}`,
        backgroundColor: Colors.textarea?.textareaBackgroundColor,
        borderError: `1px solid ${Colors.textarea?.textareaBorderError}`,
        borderSuccess: `1px solid ${Colors.textarea?.textareaBorderSuccess}`,
        backgroundColorDisabled: Colors.textarea?.textareaBackgroundColorDisabled,
        backgroundColorDisabledClick: Colors.textarea?.textareaBackgroundColorDisabledClick,
    },
    tooltip: {
        left: '0px',
        zIndex: 10,
        bottom: '-35%',
        display: 'none',
        fontSize: '11px',
        borderRadius: '2px',
        padding: '2px 10px',
        position: 'absolute',
        topAfterBefore: '100%',
        leftAfterBefore: '85%',
        fontFamily: 'sans-serif',
        positionAfterBefore: 'absolute',
        pointerEventsAfterBefore: 'none',
        color: Colors.textarea?.tooltipColor,
        borderAfterBefore: 'solid transparent',
        border: `1px solid ${Colors.textarea?.tooltipBorder}`,
        backgroundColor: Colors.textarea?.tooltipBackgroundColor,
        boxShadow: `0px 0px 3px 1px ${Colors.textarea?.tooltipColorBoxShadow}`,
    },
    symbol: {
        left: '10px',
        bottom: '10px',
        fontSize: '13px',
        position: 'absolute',
        fontFamily: 'sans-serif',
        color: Colors.textarea?.symbol,
        fontFamilyDisabled: 'sans-serif',
        fontFamilyDisabledClick: 'sans-serif',
        colorDisabled: Colors.textarea?.symbolHight,
        colorDisabledClick: Colors.textarea?.primary,
    },
    messageError: {
        required: 'Campo requerido.',
        numeric: 'Solo puede contener números',
        email: 'El formato de email no es válido',
        letter: 'El campo debe contener solo letra0s.',
        minimum: (value: number) => `El valor es mínimo: ${numberFormat(Number(value))}.`,
        maximum: (value: number) => `El valor es máximo: ${numberFormat(Number(value))}.`,
        date: (value: string) => `La fecha no es valida: ${numberFormat(Number(value))}.`,
        hour: (value: string) => `La hora no es validad: ${numberFormat(Number(value))}.`,
        range: (min: number, max: number) => `El rango de caracteres es de ${min} a ${max}.`,
        pass: 'La contraseña debe tener al entre 8 y 16 caracteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.',
    },
    loading: {
        color: Colors.loading?.color
    },
    tooltipTextArea: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    },
    tooltipLabel: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    }
}

// Config init textarea
export const useInitConfigTextArea = (): [TDefaultTextAreaStyle, (newStyles: TDefaultTextAreaStyle) => void] => {

    const configTextAreaStyles = useCallback((newStyles: TDefaultTextAreaStyle) => {
        defaultStyle = {
            container: {
                ...defaultStyle.container,
                ...(newStyles?.container || {})
            },
            label: {
                ...defaultStyle.label,
                ...(newStyles?.label || {})
            },
            tooltip: {
                ...defaultStyle.tooltip,
                ...(newStyles?.tooltip || {})
            },
            textarea: {
                ...defaultStyle.textarea,
                ...(newStyles?.textarea || {})
            },
            symbol: {
                ...defaultStyle.symbol,
                ...(newStyles?.symbol || {})
            },
            messageError: {
                ...defaultStyle.messageError,
                ...(newStyles?.messageError || {})
            },
            loading: {
                ...defaultStyle.loading,
                ...(newStyles?.loading || {})
            },
            tooltipTextArea: {
                ...defaultStyle.tooltipTextArea,
                ...(newStyles?.tooltipTextArea || {})
            },
            tooltipLabel: {
                ...defaultStyle.tooltipLabel,
                ...(newStyles?.tooltipLabel || {})
            },
            boxTextArea: {
                ...defaultStyle.boxTextArea,
                ...(newStyles?.boxTextArea || {})
            }
        }
    }, [])
    return [defaultStyle, configTextAreaStyles]
}